import {
  GroupSettingsGet,
  GroupSettingsSet,
  SaveLocalScheduleParams
} from './group-settings.model';
import { DeviceGroupScheduleModel } from '@models/digital-signage/device-group-schedules.model.ts';
import { LOCAL_SCHEDULE_ID_PREFIX } from '@modules/digital-signage/utils/schedule.utils.ts';

export const playlistScheduleSlice = (
  set: GroupSettingsSet,
  getState: GroupSettingsGet
) => ({
  initSchedules: (schedules: DeviceGroupScheduleModel[]) =>
    set({ schedules, savedSchedules: schedules }),

  saveLocalSchedule: ({ id, body }: SaveLocalScheduleParams) => {
    const { schedules } = getState();
    const now = new Date().toISOString();
    const existing = schedules.find((schedule) => schedule._id === id);
    const schedule = {
      ...existing,
      _id: id ?? `${LOCAL_SCHEDULE_ID_PREFIX}${crypto.randomUUID()}`,
      name: body.name,
      playlist: body.playlist,
      startDate: body.startDate ?? null,
      endDate: body.endDate ?? null,
      schedules: body.schedules,
      createdAt: existing?.createdAt ?? now,
      updatedAt: now
    };

    set({
      schedules: existing
        ? schedules.map((item) => (item._id === id ? schedule : item))
        : [...schedules, schedule]
    });
  },

  removeLocalSchedule: (id: string) =>
    set({
      schedules: getState().schedules.filter((schedule) => schedule._id !== id)
    }),

  resetSchedules: () => set({ schedules: [], savedSchedules: [] })
});
